
const LIVE = `https://bespokenapp.com/api/`
const TEST = `https://bespokenapp.com/dev/`


// Toggles
const DOMAIN = TEST;
export const isLife = false;

export const DEFAULT_LANGUAGE = `en`;
export const BS = `${DOMAIN}api/`;
export const APP_NAME: string = `BeSpoken`;
export const fileUrl: string = `${DOMAIN}api/api/File/`;
export const fileUrlDownload: string = `${DOMAIN}api/api/File/download/`;
export const GlobalDelay: number = 1000;
const SWAGGER: string = `${DOMAIN}api/swagger/index.html`;
export const AGM_KEY: string = `AIzaSyARBya2cNTTGDWtFjgRolSb3Pp3scWzA1k`;
export const SAR_CURRENCY: string = `images/icons/sar-currency.svg`;


// Angular cli version : 18.2.0
// Node version : 20.11.1

// To Switch From/To Prod/Testing Change :
// 404 ERROR PAGE HTML redirect link
// provideClientHydration
// publishedUrl
// deeplink
// envLinks
// isLife FOR PAYMENT ******
// { provide: APP_BASE_HREF, useValue: '/test/' }
//  addPreloadLink fun
//  ReWrite File links
// <meta name="robots" content="noindex, nofollow">

// How To Run SSR In Real-Time (development) Locally
// npm install -g nodemon    (One Time)
// npm install -g concurrently    (One Time)
// 1. npm run build:ssr:watch
// 2. new window in terminal then > npm run serve:ssr:watch
// 3. Note : every time you change a file you gotta refresh browser after nodemon says in ssr terminal : starting `node etc etc . .`

// HOW TO DEPLOY SSR BUILD TO IIS :
// angular.json "optimization": false, >> to true
// angular.json "prerender": true, >> to false
// 1. npm run boost-live
// 2. Create root folder, drop dist folder in the root folder
// 3. Create server.js and web.config in root (because node.js doesn't support es6), there is server.js and web.config already created and ready in-project root
// 4. root folder now should have dist-folder & web.config & server.js
// 5. IIS deploy to root

// Things To Keep In Mind :
// defer /
// "prerender" and "optimization" and "styles" and and "scripts" >> angular.json in general /
//  provideClientHydration /
// cd.detectChanges can cause some issues if it's in the wrong place in the cycle /
// remember how mergeApplicationConfig and provideClientHydration works together /
// aos is not ESM >> CommonJS AMD dependencies (ssr terminal errors in general)
// <httpErrors existingResponse="PassThrough" />   in web.config

// Back Up
// In angular.json scripts and styles
// "styles": [
//     "@angular/material/prebuilt-themes/azure-blue.css",
//     "./node_modules/bootstrap/dist/css/bootstrap.min.css",
//     "./node_modules/aos/dist/aos.css",
//     "public/styles/main.css"
//   ],
//   "scripts": [
//     "./node_modules/jquery/dist/jquery.min.js",
//     "./node_modules/bootstrap/dist/js/bootstrap.bundle.min.js",
//     "node_modules/aos/dist/aos.js"
//   ],
// Back Up


// In Order For Express Status (301 404) To Work You Must Install "@nguniversal/express-engine" Then Provide Them Via servers.ts
// { provide: REQUEST, useValue: req },
// { provide: RESPONSE, useValue: res }


// ON BUILDING
// "outputHashing": "all",
// "optimization": true,
// "extractLicenses": true,
// "sourceMap": false